import { Component, OnInit, Input } from '@angular/core';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup,FormArray, Validators } from '@angular/forms';
import Swal from 'sweetalert2'
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { FeedbackCommonComponent } from '../../sub-admin/feedback-common/feedback-common.component';



@Component({
  selector: 'app-repair-complted-list',
  templateUrl: './repair-complted-list.component.html',
  styleUrls: ['./repair-complted-list.component.scss']
})
export class RepairCompltedListComponent implements OnInit {

  @Input() selectedOutlet: any;
  monthTab: any;
  completedTabArr: any;
  selectedTabIndex: any;
  userType: any;
  selected_common_process_id: any;


  constructor(private auth:AuthServiceService,private local:LocalServiceService,private router:Router, private toastr: ToastrService, private formBuilder: FormBuilder,private modalService: NgbModal, private spinner: NgxSpinnerService,) { }

  completedArr=[];
  notesText:any;
  form: FormGroup;
  edpform: FormGroup;
  search: any;
  savedSecretData: any;
  private modalRef;
  repairAdmins: any;
  isWarranty = 0;
  years = [];
  selectedYear: any = new Date().getFullYear();
  currentYear: any = new Date().getFullYear();

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      published: true,
      repair: this.formBuilder.array([]),
    });

    this.edpform = this.formBuilder.group({
      adminId: [""],
      repairBy: [""],
      costByWarranty: [""],
      note:[""],
      note1: [""],
      note2: [""],
      note3: [""],
      note4: [""]
    });
    // this.getCompletedListData();
    this.getAdmins();
    this.yearsData();
  }

  ngOnChanges(changes) {
    // console.log(changes.selectedOutlet.currentValue,'-----------------------changes')

    const { userType } = this.local.getUser();
    this.userType = userType;

    this.selectedOutlet = changes.selectedOutlet.currentValue;
    this.getCompletedListData(this.selectedOutlet);
  }

  getRepair(i) {
    return (<FormArray>this.form.get('repair')).controls[i].invalid;
  }

  get edp() { return this.edpform.controls; }

  yearsData(){
    this.years = [
      {id:'1',name:'2020'},
      {id:'2',name:'2021'},
      {id:'3',name:'2022'},
      {id:'4',name:'2023'},
      {id:'5',name:'2024'},
      {id:'6',name:'2025'},
      {id:'7',name:'2026'},
      {id:'8',name:'2027'},
      {id:'9',name:'2028'},
      {id:'10',name:'2029'},
      {id:'11',name:'2030'},
    ]
  }

  onChangeYear(event){
    // this.spinner.show();
    if(event.target.value){
      // alert(event.target.value)
      this.selectedYear = event.target.value;
      this.getCompletedListDataFront(this.selectedOutlet, this.monthTab, this.selectedYear, this.selectedTabIndex);
      // this.spinner.hide();
    }
  }


  getCompletedListData(outletId, month = 0, year = this.selectedYear){

    // alert("COMPLETED REPAIR COMPONENT")

    // console.log(outletId, month, year,'======================= o m y')

    let isGuest = (this.userType == 'guest')?'1':'0';

    let formData = new FormData();
    formData.append('outletId', outletId);
    formData.append('year', this.selectedYear);
    formData.append('isGuest', isGuest);

    this.auth.get_completed_repair(formData).subscribe((response:any)=>{

      this.completedArr = response.body;
      // console.log(this.completedArr,'-----------------------------completed arr')

      this.monthTab = this.completedArr[0].monthNumber;

      this.getTabSelectedCompletedProcess(this.monthTab, this.selectedYear);

      // this.spinner.hide();
    });
  }

  getCompletedListDataFront(outletId, month = 0, year = this.selectedYear, selectedTabIndex){

    // alert("COMPLETED REPAIR COMPONENT")

    console.log(outletId, month, year,'======================= o m y')

    this.spinner.show();

    this.monthTab = month;

    this.selectedTabIndex = selectedTabIndex;

    console.log(this.selectedTabIndex,'===========================================selectedTabIndex')

    let formData = new FormData();
    formData.append('outletId', outletId);
    formData.append('year', this.selectedYear);

    this.auth.get_completed_repair(formData).subscribe((response:any)=>{

      this.completedArr = response.body;
      console.log(this.completedArr,'-----------------------------completed arr')

      // if(this.completedArr.length == 1) {
      //   var monthTab = 13;
      // } else {
        
      // }

      // if(this.selectedTabIndex == 13) {
      //   alert("13")
      //   var monthTab = this.completedArr[0].monthNumber;
      // } else {
      //   if(this.selectedTabIndex > this.completedArr.length) {
      //     alert("first")
      //     var monthTab = this.completedArr[this.completedArr.length - 1].monthNumber;
      //   } else {
      //     alert("second")
      //     var monthTab = this.completedArr[this.selectedTabIndex].monthNumber;
      //   }
      // }

      // console.log(monthTab,'==============================================monthTab')
      console.log(this.monthTab,'========================================month tab')
      
      this.getTabSelectedCompletedProcess(this.monthTab, this.selectedYear);

      // this.spinner.hide();
    });
  }

  getTabSelectedCompletedProcess(month, year) {
    // this.spinner.show();
    let formData = new FormData();

    console.log(month, year, '===================================== m y')

    formData.append('month', month);
    formData.append('year', year);
    formData.append('outletId', this.selectedOutlet);

    this.auth.get_completed_process_listing_tab(formData).subscribe((response:any)=>{

      // console.log(response.body,'===============================================selected month tab')

      this.completedTabArr = response.body;

      this.spinner.hide();
      
    });
  }

  onWarranty(type) {
    // console.log(this.savedSecretData);
    const formData = new FormData();
    formData.append('processId', this.savedSecretData.id);
    formData.append('type', type);
    if (type == 1 ) {
       formData.append('isWarranty', '1');
       formData.append('costOfWarranty', this.edp.costByWarranty.value);
    } else {
      formData.append('costOfWarranty', this.edp.costByWarranty.value);
      formData.append('adminId', this.edp.adminId.value);
      formData.append('notes', this.edp.note.value);
      formData.append('isWarranty', '1');
      formData.append('notes1', this.edp.note1.value);
      formData.append('notes2', this.edp.note2.value);
      formData.append('notes3', this.edp.note3.value);
      formData.append('notes4', this.edp.note4.value);

    }

    this.auth.save_repair_process_changes(formData).subscribe((response: any) => {
      this.modalService.dismissAll();
      this.getCompletedListData(this.selectedOutlet);
      this.toastr.success(response.message);
    }, (e) => {
      this.toastr.error(e.error.message);
    })

  }

    getAdmins(){ this.auth.getAllSubadmins().subscribe((response:any)=>{
    // this.admins = response.body;
    let array2 = [1,36,37,39,40,41,42,28,60,61,55];  //hide these admins as per requirement
    this.repairAdmins = response.body.filter(e => !array2.includes(e.id));
  }) }

  showPassModal(modal,data){
    this.selected_common_process_id = data.id;
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title',backdrop:'static'});
    this.savedSecretData = data;
    // console.log(this.savedSecretData);

    console.log(data,'-----------------data')

    let note = data.repairProcesses.find(data => data.type == 1).phoneProblem;
    let notes1 = data.repairProcesses.find(data => data.type == 2).description;
    let notes2 = data.repairProcesses.find(data => data.type == 3).description;
    let note3 = data.repairProcesses.find(data => data.type == 1).name;
    let note4 = data.repairProcesses.find(data => data.type == 1).phoneModel;
    // console.log(note, notes1, notes2, note3, note4,'==================================all notes')

    let c_note = data.repairProcesses.find(data => data.type == 1).c_phoneProblem;
    let c_notes1 = data.repairProcesses.find(data => data.type == 2).c_description;
    let c_notes2 = data.repairProcesses.find(data => data.type == 3).c_description;
    let c_note3 = data.repairProcesses.find(data => data.type == 1).c_name;
    let c_note4 = data.repairProcesses.find(data => data.type == 1).c_phoneModel;

    note = (c_note.trim() == '')?note:c_note;
    notes1 = (c_notes1.trim() == '')?notes1:c_notes1;
    notes2 = (c_notes2.trim() == '')?notes2:c_notes2;
    note3 = (c_note3.trim() == '')?note3:c_note3;
    note4 = (c_note4.trim() == '')?note4:c_note4;


    this.edpform.setValue({ 'adminId': data['adminId'], 'repairBy': data.repairProcesses[1].adminName, 'costByWarranty': data['costOfWarranty'], 'note': note, 'note1': notes1, 'note2': notes2, 'note3': note3, 'note4': note4 })
    this.isWarranty = data['isWarranty'];
  }


  cancelled(id){

    Swal.fire({
      title: 'Are you sure?',
      text: "You want to delete repair!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        let data = { 'processId': id,type:'1' };

        this.auth.cancelled_repair_process(data).subscribe((response: any) => {
          this.getCompletedListData(this.selectedOutlet);
          Swal.fire(
            'Deleted!',
            'Your process has been deleted.',
            'success'
          )
        }, (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        })
      }
    })


  }

  saveListData(id){

      let data = {};

      for(let i= 0;i<this.completedArr.length;i++){
        // console.log(`complete arr`,this.completedArr[i]);
         data = (this.completedArr[i].data || []).find(e=>e.id == id);
         if(data){
          //  console.log(`In data`,data);
           break;
         }
      };

      let new_data = {'processId':id,'notes':data["notes"]}
      this.auth.save_notes_repair(new_data).subscribe((response:any)=>{
        this.toastr.success('Note Saved Successfully');
        this.getCompletedListData(this.selectedOutlet);
      }, (e) => {
        this.toastr.error(e.error.message);
      })

  }

  showCommonFeedbackModal(type) {
    this.local.setFeedbackCommonType(type);
    this.local.setCommonProcessId(this.selected_common_process_id);
    this.modalService.open(FeedbackCommonComponent, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'open_small_modal' });
  }

}

